import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Fomentoartesanal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'> {/* container, container-full-width, container container-mh */}
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Fomento Artesanal"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Mejorar el ingreso de las Personas Artesanas del Estado de Hidalgomediante la consolidación de acciones de comercialización, la asignación de espacios, el fomento de sus actividades económicas y la protección de sus tradiciones, a través de seis vertientes:
                </p>
                <ol>
                <li>
                Promoción de productos artesanales o Registro de Marca.
                </li>
                <li>
                Entrega de Financiamiento a Personas Artesanas.
                </li>
                <li>
                Capacitación para el Rescate y la Preservación del Oficio Artesanal.
                </li>
                <li>
                Entrega de Estímulos Económicos para el Reconocimiento de la Creatividad Artesanal. 
                </li>
                <li>
                Asignación de Espacios para Comercialización de Artesanías.
                </li>
                <li>
                Proyectos para el Fortalecimiento de Producción Artesanal.
                </li>
                </ol>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar el bienestar a través del ingreso de las Personas Artesanas Hidalguenses, mediante el impulso y desarrollo de actividades artesanales como son: Apoyos para promoción, producción, capacitación y comercialización.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas Artesanas que trabajen alguna rama artesanal descrita en el artículo 5 de la Ley Salvaguardia y Fomento Artesanal para el Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa está dirigido a las personas artesanas habitantes de los 84 municipios del Estado de Hidalgo que cuenten con alguna actividad artesanal considerada dentro de las 13 ramas artesanales que enuncia la Ley Salvaguardia y Fomento Artesanal para el Estado de Hldalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p>  
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Participaciòn Social y Fomento Artesanal</b></li>
                <li><b>Dirección General de Fomento Artesanal.</b></li>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. Areli Maya Monzalvo: Subsecretaria de Participación Social y Fomento Artesanal
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 713 09 66 y 771 713 04 12
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Reglas de Operación</strong></h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Fomento_Artesanal_2024_ene_31_alc7_05.pdf'
                target='_blank'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Convocatorias</strong></h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2025/Convocatoria_HH_2025.pdf'
                target='_blank'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >12ᵃ Edición del Concurso Regional de Artesanías de la Huasteca Hidalguense 2025</a>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/anexos/2025/Anexos_HH_2025.pdf'
                target='_blank'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Anexos</a>
                </li>
                </ul>

                </li>
                
                </ul>
                
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Fomentoartesanal;